export type GenderResponseBody = {
  code: string;
  name: string;
};

export type GetGendersApiResponse = /** status 200  */ GenderResponseBody[];
export type GetGendersApiArg = void;
